module.exports = __webpack_public_path__ + "img/102013.cfbbadb6.png";